"use client";

import { buildGatePoiUrl, lookupGateFeature } from "@/lib/livingMap";

const NAVY = "#102542";
const YELLOW = "#ffb800";

interface GateMapProps {
  gate: string;
}

export default function GateMap({ gate }: GateMapProps) {
  const feature = lookupGateFeature(gate);

  if (!feature) {
    return (
      <div
        className="w-full rounded-2xl border-2 border-dashed border-gray-300 flex flex-col items-center justify-center gap-2 text-center p-8"
        style={{ height: 420, color: NAVY }}
      >
        <strong className="text-lg">Mapa no disponible</strong>
        <span className="text-sm text-gray-500">
          No tenemos la ubicación de la puerta{" "}
          <strong>{gate || "—"}</strong> en el mapa de la terminal.
        </span>
      </div>
    );
  }

  const url = buildGatePoiUrl(feature);

  return (
    <div
      className="w-full rounded-2xl overflow-hidden border"
      style={{ borderColor: `${NAVY}22` }}
    >
      <iframe
        key={feature}
        src={url}
        title={`Mapa hacia la puerta ${gate}`}
        className="w-full"
        style={{ height: 480, border: "none" }}
        allow="geolocation"
        loading="lazy"
      />
      <div
        className="flex items-center gap-2 px-4 py-2 text-xs font-mono uppercase tracking-wider"
        style={{ backgroundColor: `${YELLOW}1a`, color: "#7a5a00" }}
      >
        <span
          className="w-3 h-px inline-block"
          style={{ backgroundColor: YELLOW }}
        />
        Ruta hacia la puerta {gate}
      </div>
    </div>
  );
}
